import { useAccountsService } from '@restworld/data-services';
import { useAuthContext } from '@restworld/feature-authentication';
import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';

export function useDeleteAccountForm() {
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const acc = useAccountsService();
  const authContext = useAuthContext();
  const router = useRouter();

  function onClose() {
    setOpen(false);
  }

  function onOpen() {
    setOpen(true);
  }

  const deleteAccount = useCallback(async () => {
    setLoading(true);
    try {
      await acc.delete({ userId: authContext?.user?.id as string });
      setLoading(false);
      authContext.invalidateSession();
      router.push('/');
    } catch (error) {
      setLoading(false);
    }
  }, [acc, authContext, router]);

  const onSubmit = () => {
    deleteAccount();
  };

  return {
    open,
    onClose,
    onOpen,
    loading,
    onSubmit,
  };
}
